import { Card, Divider, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import { useBuscarInfoUser } from "../hooks/useBuscarInfoUser";
import { useBuscarPeu } from "../hooks/useBuscarPeu";
import {
  ContainerModal,
  ItemTextModal,
  ItemWrapper,
  TextModal,
  Title,
} from "../styles";
import { formatPhoneNumber } from "../../../uteis/formatPhoneNumber";

export default function ModalPeu({
  id,
  isOpen,
}: {
  id: number;
  isOpen: boolean;
}) {
  const { peu, isLoading } = useBuscarPeu(id, isOpen);
  const peuId = peu?.CotasUsuariosTable.id;

  const { infoUser, isLoading: isLoadingInfoUser } = useBuscarInfoUser(
    peuId,
    isOpen && !!peuId
  );

  if (isLoading || isLoadingInfoUser) {
    return <p>{"Carregando Informa\u00e7\u00f5es..."}</p>;
  }

  if (!peu || !infoUser?.UsuarioTable) {
    return (
      <p>
        {"Nenhuma informa\u00e7\u00e3o de contato encontrada para este per\u00edodo."}
      </p>
    );
  }

  return (
    <Card
      title={<Title>{"Informa\u00e7\u00f5es do Propriet\u00e1rio"}</Title>}
      style={{
        width: "100%",
        marginTop: "20px",
        borderRadius: "10px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <ContainerModal>
        {[
          {
            label: "Nome",
            value:
              infoUser?.UsuarioTable.nome +
              " " +
              infoUser?.UsuarioTable.sobrenome,
          },
          {
            label: "Email",
            value: infoUser?.UsuarioTable.email,
          },
          {
            label: "Celular",
            value: (
              <>
                {formatPhoneNumber(infoUser?.UsuarioTable.celular ?? "")}
                <CopyOutlined
                  onClick={() => {
                    if (infoUser?.UsuarioTable.celular) {
                      navigator.clipboard.writeText(
                        infoUser.UsuarioTable.celular
                      );
                      message.success(
                        "N\u00famero copiado para a \u00e1rea de transfer\u00eancia!"
                      );
                    }
                  }}
                  style={{
                    marginLeft: 8,
                    cursor: "pointer",
                    color: "#1677ff",
                  }}
                />
              </>
            ),
          },
        ].map((item, index) => (
          <ItemWrapper key={index}>
            <ItemTextModal>{item.label}</ItemTextModal>
            <TextModal>{item.value}</TextModal>
            {index < 8 && <Divider />}
          </ItemWrapper>
        ))}
      </ContainerModal>
    </Card>
  );
}
